import styled from 'styled-components';

import { CloseButton } from '../../sharedStyledComponents/Components';
import ButtonGoActive from '../../buttons/ButtonGoActive';

export const Background = styled.img`
  position: absolute;
  width: 673;
  height: 430;
  top: 62;
  left: 176;
`;

export const HeaderContainer = styled.div`
  position: absolute;
  width: 165;
  height: 34;
  top: 81;
  left: 430;
`;

export const HeaderTitle = styled.h2`
  font-family: Quicksand Bold;
  font-size: 27;
  color: #ffffff;
  text-align: center;
  margin: 0;
`;

export const Burst = styled.img`
  position: absolute;
  width: 265;
  height: 265;
  animation: rotation 3s ease-out forwards;
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(45deg);
    }
  }
`;

export const MissionIconContainer = styled.div`
  top: 208;
  left: 260;
  scale: 1.44;
  animation: popup 0.5s ease-out;

@keyframes popup {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`;

export const TFEName = styled.h3`
  height: 40;
  font-family: Quicksand Bold;
  font-size: 27;
  color: #ffffff;
  margin: 0;
`;

export const TFESubDescription = styled.p`
  margin: 0;
  width: 330px;
  min-height: 21px;
  font-family: Open Sans;
  font-size: 17;
  color: #ffffff;
`;

export const TFEDescription = styled.p`
  margin: 0;
  width: 330px;
  min-height: 92px;
  font-family: Open Sans;
  font-size: 17;
  color: #ffffff;
  overflow: hidden;
`;

export const Decoline = styled.img`
  width: 330;
  height: 16;
`;

export const CloseModalButton = styled(CloseButton)`
  position: absolute;
  z-index: 1;
  top: 75;
  left: 814;
`;

export const GoButton = styled(ButtonGoActive)`
  position: absolute;
  top: 443;
  left: 387;
`;

export const DescriptionContainer = styled.div`
  height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  width: 653px;
  height: 282px;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 215px;
`;
